Namespace 'AccountSettings.OperatorStatus'

class AccountSettings.OperatorStatus.OperatorStatusNameView extends Backbone.View
  template: JST["backbone/templates/account_settings/operator_statuses/operator_status_name"]

  initialize: (options) ->
    @inputID = options.id
    @statusName = options.name
    super

  render: =>
    @$el.html @template(inputID: @inputID, statusName: @statusName)
    @

  setName: (name) =>
    @statusName = name
